import { FC } from "react";
import Modal from "./ui/Modal";
import Button from "./ui/Button";
import appStore from "../stores/appStore";
import { observer } from "mobx-react-lite";
import CloseIcon from "./icons/CloseIcon";

interface CityModalProps {
  isOpen: boolean;
  onClose: () => void;
  isMobile?: boolean;
}

const CityModal: FC<CityModalProps> = ({
  isOpen,
  onClose,
  isMobile = false,
}) => {
  const selectCity = (city: string) => {
    appStore.setCity(city);

    if (!isMobile) {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={
        isMobile ? "h-[80vh] !p-0 !w-[363px] " : "!p-0 min-h-[350px] h-full"
      }
      closeButton={false}
    >
      <div
        className={
          "flex flex-row items-center " +
          (isMobile ? "p-[20px]" : "p-[30px] pb-0")
        }
      >
        <h2 className="text-[22px] font-bold text-[#232323] flex-1">
          Выбрать город
        </h2>
        <button type="button" onClick={onClose} className={"self-end !p-0"}>
          <CloseIcon
            width={isMobile ? 27 : 32}
            height={isMobile ? 27 : 32}
            className="text-[#232323] hover:text-[#383181]"
          />
        </button>
      </div>
      <div
        className={
          "flex flex-col  gap-[15px] " +
          (isMobile
            ? "pt-[6px] overflow-y-auto h-[64vh] p-[20px]"
            : "p-[30px]")
        }
      >
        {appStore.cities.map((i) => {
          return (
            <button
              key={i.name}
              onClick={() => selectCity(i.name)}
              className={
                "cursor-pointer !text-[18px] font-semibold tracking-[-0.02em] text-left !p-0 " +
                (appStore.selectedCity == i.name
                  ? "text-[#3256F3]"
                  : "text-[#474A51]")
              }
            >
              {i.name}
            </button>
          );
        })}
      </div>
      <div className={isMobile ? "sticky bottom-0 w-full p-[20px] mt-2" : ""}>
        {isMobile && (
          <div className="relative">
            <div className="absolute inset-x-0 -top-[20px] h-16 w-[130%] left-[-10%]  backdrop-blur-[2px] z-10" />
            <Button
              style="primary"
              onClick={onClose}
              className="w-full !rounded-[15px] h-[49px] relative z-10"
            >
              Подтвердить
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default observer(CityModal);
